import { DEEP_LINK_PREFIX_LOCAL } from "../../features/desktop-app/DesktopAppConstants";

export function buildDeepLink(urlPath: string): string {
    return window.location.hostname === "localhost"
        ? DEEP_LINK_PREFIX_LOCAL + urlPath
        : process.env.DESKTOP_APP_DEEPLINK_PREFIX + urlPath;
}
